import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
// import colors from 'src/utils/colors';

interface PasswordProps {
  isFormSubmitted: boolean;
  onChange: (data: { password: string; isPasswordValid: boolean; id: string }) => void;
  clearInput?: boolean;
  inputStyle?: React.CSSProperties;
  style?: React.CSSProperties;
  className?: string;
  error?: string;
  validateLength?: boolean;
  hintText?: string;
  floatingLabelText?: string;
  id?: string;
  floatingLabelFixed?: boolean;
}

const Password: React.FC<PasswordProps> = ({
  isFormSubmitted,
  onChange,
  clearInput = false,
  inputStyle = { marginTop: '8px' },
  style = { width: '100%', height: '58px' },
  className = '',
  error = null,
  validateLength = false,
  hintText = 'Password',
  id = 'password'
}) => {
  const [value, setValue] = useState<string>('');
  const [isPasswordValid, setIsPasswordValid] = useState<boolean>(false);

  useEffect(() => {
    if (clearInput) {
      setValue('');
    }
  }, [clearInput]);

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    const isValid = validateLength ? newValue.length >= 8 : newValue.length > 0;
    setValue(newValue);
    setIsPasswordValid(isValid);
    onChange({ password: newValue, isPasswordValid: isValid, id });
  };

  const showErrorText = (): string | null => {
    if (isFormSubmitted) {
      if (error) {
        return error;
      }
      if (!isPasswordValid) {
        if (value === '') {
          return 'This field is required';
        }
        if (validateLength) {
          return 'Password must be at least 8 characters.';
        }
      }
    }
    return null;
  };

  return (
    <TextField
      id={id}
      variant="standard"
      className={`${className} ${showErrorText() ? 'sl-form-input--error' : ''}`}
      placeholder={hintText}
      type="password"
      value={value}
      onChange={handlePasswordChange}
      inputProps={{
        style: inputStyle
      }}
      style={style}
      helperText={showErrorText()}
    />
  );
};

export default Password;
